import { createContext } from 'react'

const DaiContext = createContext()

export default DaiContext
